.root {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.moneyInteger {
  font-size: 1.4rem;
}

.indented {
  margin-left: 1.6rem;
}

.divider {
  border-top: 1px solid #ccc;
  margin: 8px 0;
  width: 100%;
}
